import { FieldTypes, SourceFormFieldDefinition } from '../models';
import { getAPIKeyField } from './utils/api-key';


export const FRESH_SERVICE_SOURCE_TEMPLATE: Array<Array<SourceFormFieldDefinition>> = [
  [
    {
      ...getAPIKeyField({
        hint: 'Enter the API key obtained from the Profile Picture → Profile Settings → Copy the API Key.',
      })
    }
  ],
  [
    {
      key: 'domainName',
      fieldId: 'domain-name',
      widget: FieldTypes.TEXT_FIELD,
      fieldType: 'string',
      widgetOptions: { name: 'domainName', label: 'Domain Name', required: true },
      hint: 'Enter the domain name obtained from the three dots on Left hand side bar → Admin → Account Settings → Helpdesk Rebranding → Helpdesk/Portal URL in the form https://<domain_name>.freshservice.com/',
      buildParamsKey: 'domain_name',
      validations: [
        {
          type: 'required'
        }
      ]
    }
  ]
];
